import { IVehicle } from "interfaces/session/IVehicle";

export function createMakeImageSource(vehicle?: IVehicle) {
  if (vehicle === null) {
    return `${process.env.NEXT_PUBLIC_ROOT_URL}/cms/pubicImages/images/vehicle-dark.webp`;
  }
  if (vehicle === undefined) {
    return `${process.env.NEXT_PUBLIC_ROOT_URL}/images/car-logos/make_fallback.png`;
  }
  if (vehicle.make) {
    return `${process.env.NEXT_PUBLIC_ROOT_URL}/images/car-logos/${vehicle.make.toUpperCase()}_16051144.png`;
  }
  return `${process.env.NEXT_PUBLIC_ROOT_URL}/cms/pubicImages/images/vehicle-dark.webp`;
}
